import React from "react";

import { connect } from "react-redux";
import {
  editarEmpresa,
  guardarEmpresa,
} from "../../components/empresas/EmpresaService";
import {
  getConfiguracionCorreo,
  guardarConfiguracionCorreo
} from "../../components/correo/CorreoService";
import MensajeFlash from '../mensajeFlash/MensajeFlash';
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { Form, Row, Col, Button } from "react-bootstrap";
import {
  URL,
  getAuthorizationHeader,
} from "../../constans/constants";
import axios from "axios";
import { logout } from "../login/SesionService";

class ConfiguracionApp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      hostApp: "",
      puertoApp: "",
      esquemaApp: "",
      propiedades: [],
      ldapEnabled: false,
      sslEnabled: false,
      ldapHost: "",
      ldapPort: "",
      ldapBinDN: "",
      ldapBinPassword: "",
      mensajeFlash: "",
      mostrarMensajeFlash: false,
      mensajeFlashSeverity: "",
      confirmContraseña: "",
      openPantallaCarga: false,
      validated: false
    };
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  checkedChange = (event) => {
    this.setState({
      [event.target.name]: event.target.checked,
    });
  };

  componentDidMount = () => {
    axios.get(URL + "propiedades/listar", getAuthorizationHeader()).then(
      (res) => {
        if (res.data.error == false) {
          this.setState({ propiedades: res.data.datos });
          res.data.datos.forEach(propiedad => {
            if(propiedad.nombre == "isa.app.schema"){
              this.setState({esquemaApp:propiedad.valor})
            }else if(propiedad.nombre == 'isa.app.host'){
              this.setState({hostApp:propiedad.valor})
            }else if(propiedad.nombre == 'isa.app.port'){
              this.setState({puertoApp:propiedad.valor})
            }else if(propiedad.nombre == 'ldap.host'){
              this.setState({ldapHost:propiedad.valor})
            }else if(propiedad.nombre == 'ldap.port'){
              this.setState({ldapPort:propiedad.valor})
            }else if(propiedad.nombre == 'ldap.bindDN'){
              this.setState({ldapBinDN:propiedad.valor})
            }else if(propiedad.nombre == 'ldap.bindPassword'){
              this.setState({ldapBinPassword:propiedad.valor})
            }else if(propiedad.nombre == 'ldap'){
              this.setState({ldapEnabled:propiedad.valor})
            }
          })
        }
      },
      (error) => {
        if (error.response.status === 401) {
          logout();
        }
        return error;
      }
    );


  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ openPantallaCarga: true });
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      this.setState({ validated: true, openPantallaCarga: false})
    }else{
      this.setState({ validated: true })
      const json = {
        host: this.state.host,
        puerto: this.state.puerto,
        replyTo: this.state.replyTo,
        alias: this.state.alias,
        disponible: this.state.disponible,
        username: this.state.username,
        contraseña: this.state.contraseña,
        mecanicoAutenticacion: this.state.mecanicoAutenticacion,
        authEnabled: this.state.authEnabled,
        sslEnabled: this.state.sslEnabled,
      };

      if(json.contraseña !== this.state.confirmContraseña){
        this.setState({
          mensajeFlashSeverity: "danger",
          mensajeFlash: "Las contraseñas no coinciden ",
          mostrarMensajeFlash: true,
          openPantallaCarga: false
        })
      }else{
        guardarConfiguracionCorreo(json).then(response => {
          if (!response.error) {
            this.setState({ mensajeFlashSeverity: "success" });
          } else {
            this.setState({ mensajeFlashSeverity: "danger" });
          }
          this.setState({
            mensajeFlash: response.mensaje,
            mostrarMensajeFlash: true,
            openPantallaCarga: false
          });
        });
      }
    }
  }

  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensajeFlash: false,
    });
  };

  render() {
    return (
      <div className="dashboardContent">
        <div className="container-fluid">
          <MensajeFlash
            mensaje={this.state.mensajeFlash}
            open={this.state.mostrarMensajeFlash}
            severity={this.state.mensajeFlashSeverity}
            handleClose={this.handleCloseMensajeFlash} />
          <div className="sectionHeader">
            <h1 className="pageTitle"> Configuracion </h1>
          </div>
          <div className="contentPage card" style={{ marginTop: "20px" }}>
            <div className="form-content">
            <Row>
                  <Col xs={6} style={{ marginTop: '20px', marginBottom: '20px' }}>
                    <h6>
                      MIRECIBO
                    </h6>
                  </Col>
                </Row>
                <Row>
                  <Col xs={6} style={{ paddingBottom: "20px" }}>
                    <Form.Group className="form-group md-input">
                      <input
                        label="esquemaApp"
                        name="esquemaApp"
                        placeholder=" "
                        className="form-control md-form-control"
                        onChange={this.handleChange}
                        value={this.state.esquemaApp}
                        required
                      />
                      <Form.Label className="md-label">Esquema</Form.Label>
                      <Form.Control.Feedback type="invalid">
                        <p><small>Campo requerido</small></p>
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col xs={6} style={{ paddingBottom: "20px" }}>
                    <Form.Group className="form-group md-input">
                      <input
                        label="HOST "
                        name="hostApp"
                        placeholder=" "
                        className="form-control md-form-control"
                        onChange={this.handleChange}
                        value={this.state.hostApp}
                        required
                      />
                      <Form.Label className="md-label">Host</Form.Label>
                      <Form.Control.Feedback type="invalid">
                        <p><small>Campo requerido</small></p>
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col xs={6} style={{ paddingBottom: "20px" }}>
                    <Form.Group className="form-group md-input">
                      <input
                        label="Puerto"
                        name="puertoApp"
                        placeholder=" "
                        className="form-control md-form-control"
                        onChange={this.handleChange}
                        value={this.state.puertoApp}
                        required
                      />
                      <Form.Label className="md-label">Puerto</Form.Label>
                      <Form.Control.Feedback type="invalid">
                        <p><small>Campo requerido</small></p>
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              <Row>
                <Col xs={6} >
                  <h6>
                    DIECTORIO DE USUARIOS
                  </h6>
                </Col>
              </Row>
              <Form
                ref="form"
                onSubmit={this.handleSubmit}
                noValidate
                validated={this.state.validated}
              >
                <Row style={{ marginTop: '20px' }}>
                  <Col xs={6} style={{ paddingBottom: "20px" }}>
                    <Form.Group className="form-group md-input">
                      <input
                        label="Host"
                        name="host"
                        placeholder=" "
                        className="form-control md-form-control"
                        onChange={this.handleChange}
                        value={this.state.ldapHost}
                        required
                      />
                      <Form.Label className="md-label">Host</Form.Label>
                      <Form.Control.Feedback type="invalid">
                        <p><small>Campo requerido</small></p>
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col xs={6} style={{ paddingBottom: "20px" }}>
                    <Form.Group className="form-group md-input" >
                      <input
                        label="Puerto"
                        name="puerto"
                        placeholder=" "
                        className="form-control md-form-control"
                        onChange={this.handleChange}
                        value={this.state.ldapPort}
                        required
                      />
                      <Form.Label className="md-label">Puerto</Form.Label>
                      <Form.Control.Feedback type="invalid">
                        <p><small>Campo requerido</small></p>
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col xs={6} style={{ paddingBottom: "20px" }}>
                    <Form.Group className="form-group md-input">
                    <Form.Control
                        name="binddn"
                        placeholder=" "
                        className="form-control md-form-control"
                        onChange={this.handleChange}
                        value={this.state.ldapBinDN}
                        required
                    />
                    <Form.Label className="md-label">Base-dn</Form.Label>
                    <Form.Control.Feedback type="invalid">
                    <p><small>Direccion de email no valida</small></p>
                    </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                  <Col xs={6} style={{ paddingBottom: "20px" }}>
                    <Form.Group className="form-group md-input">
                      <Form.Control
                        name="binddn"
                        placeholder=" "
                        className="form-control md-form-control"
                        onChange={this.handleChange}
                        value={this.state.ldapBinDN}
                        required
                      />

                      <Form.Label className="md-label">Bind-dn</Form.Label>
                      <Form.Control.Feedback type="invalid">
                        <p><small>Direccion de email no valida</small></p>
                      </Form.Control.Feedback>
                    </Form.Group>
                  
                  </Col>
                  <Col xs={6} style={{ paddingBottom: "20px" }}>
                    <Form.Group className="form-group md-input">
                      <input
                        label="Contraseña"
                        name="contraseña"
                        placeholder=" "
                        className="form-control md-form-control"
                        value={this.state.ldapBinPassword}
                        onChange={this.handleChange}
                        type="password"
                        required
                      />
                      <Form.Label className="md-label">Bind-Password</Form.Label>
                      <Form.Control.Feedback type="invalid">
                        <p><small>Campo requerido</small></p>
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col xs={6}>
                    <Form.Group className="form-group md-input">
                      <Form.Check
                        name="disponible"
                        color="primary"
                        label="Activo"
                        checked={this.state.ldapEnabled}
                        onChange={this.checkedChange} />
                    </Form.Group>
                  </Col>
                </Row>
               
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    p: 2,
                    marginTop: '20px',
                    marginBottom: '20px',
                    marginRight: '20px'
                  }}
                >
                  <Button color="primary" type="submit">
                    Guardar
                  </Button>
                </div>
              </Form>
            </div>
          </div>
          <PantallaCarga open={this.state.openPantallaCarga} />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  guardarEmpresa: (value) => dispatch(guardarEmpresa(value)),
  editarEmpresa: (value) => dispatch(editarEmpresa(value)),
});

export default connect(null, mapDispatchToProps)(ConfiguracionApp);
